export const GET_SHARE_TEMPLATE = 'GET_SHARE_TEMPLATE';
export const GET_SHARE_TEMPLATE_SUCCESS = 'GET_SHARE_TEMPLATE_SUCCESS';
export const GET_SHARE_TEMPLATE_FAILURE = 'GET_SHARE_TEMPLATE_FAILURE';

export const UPDATE_TEMPLATE_DETAILS = 'UPDATE_TEMPLATE_DETAILS';
export const UPDATE_TEMPLATE_DETAILS_SUCCESS =
    'UPDATE_TEMPLATE_DETAILS_SUCCESS';
export const UPDATE_TEMPLATE_DETAILS_FAILURE =
    'UPDATE_TEMPLATE_DETAILS_FAILURE';

export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const SET_PRODUCT_TO_BE_ADDED = 'SET_PRODUCT_TO_BE_ADDED';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';

export const MORE_CREATE_PRODUCT_TEMPLATE = 'MORE_CREATE_PRODUCT_TEMPLATE';
export const MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'MORE_CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const MORE_CREATE_PRODUCT_TEMPLATE_FAILURE =
    'MORE_CREATE_PRODUCT_TEMPLATE_FAILURE';
export const MORE_RESET_CREATE_TEMPLATE = 'MORE_RESET_CREATE_TEMPLATE';
export const RESET_UPDATE_TEMPLATE_DETAILS = 'RESET_UPDATE_TEMPLATE_DETAILS';

export const LIST_SHARE_USER = 'LIST_SHARE_USER';
export const SET_SELECTED_USER = 'SET_SELECTED_USER';
export const SET_SELECTED_USER_INFO = 'SET_SELECTED_USER_INFO';
export const LIST_SHARE_USER_SUCCESS = 'LIST_SHARE_USER_SUCCESS';
export const LIST_SHARE_USER_FAILURE = 'LIST_SHARE_USER_FAILURE';

export const GET_SEARCH_PARAM = 'GET_SEARCH_PARAM';
export const GET_SEARCH_PARAM_SUCCESS = 'GET_SEARCH_PARAM_SUCCESS';
export const GET_SEARCH_PARAM_FAILURE = 'GET_SEARCH_PARAM_FAILURE';

export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'MORETEMPLATES: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'MORETEMPLATES: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'MORETEMPLATES: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

// export const GET_DETAILED_PRODUCT_TEMPLATE_LIST ='MORE_TEMPLATES:GET_DETAILED_PRODUCT_TEMPLATE_LIST';
// export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS ='MORE_TEMPLATES:GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
// export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE ='MORE_TEMPLATES:GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'SET_PRODUCT_TEMPLATE_REFINE_DATA';

export const GET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';

export const SET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';
export const SET_EXPANDED_FILTER_VIEW = 'SET_EXPANDED_FILTER_VIEW';

export const GET_CATEGORY_NAME = 'GET_CATEGORY_NAME';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

export const SET_TEMPLATE_PAGE_DETAILS = 'SET_TEMPLATE_PAGE_DETAILS';
export const CLEAR_TEMPLATE_PAGE_DETAILS = 'CLEAR_TEMPLATE_PAGE_DETAILS';

export const GET_USER_LIST = 'GET_USER_LIST';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';

export const MORE_TEMPLATES_VALIDATE_PRODUCTS_SURGERY =
    'MORE_TEMPLATES_PRODUCTS:VALIDATE_PRODUCTS_SURGERY';
export const MORE_TEMPLATES_VALIDATE_PRODUCTS_SUCCESS_SURGERY =
    'MORE_TEMPLATES_PRODUCTS:VALIDATE_PRODUCTS_SUCCESS_SURGERY';
export const MORE_TEMPLATES_VALIDATE_PRODUCTS_FAILURE_SURGERY =
    'MORE_TEMPLATES_PRODUCTS: VALIDATE_PRODUCTS_FAILURE_SURGERY';
export const CLEAR_VALIDATED_PRODUCTS_SURGERY =
    'PRODUCTS: CLEAR_VALIDATED_PRODUCTS_SURGERY';

export const MORE_TEMPLATES_VALIDATE_PRODUCTS_EQUITY =
    'MORE_TEMPLATES_PRODUCTS:VALIDATE_PRODUCTS_EQUITY';
export const MORE_TEMPLATES_VALIDATE_PRODUCTS_SUCCESS_EQUITY =
    'MORE_TEMPLATES_PRODUCTS:VALIDATE_PRODUCTS_SUCCESS_EQUITY';
export const MORE_TEMPLATES_VALIDATE_PRODUCTS_FAILURE_EQUITY =
    'MORE_TEMPLATES_PRODUCTS: VALIDATE_PRODUCTS_FAILURE_EQUITY';
export const CLEAR_VALIDATED_PRODUCTS_EQUITY =
    'PRODUCTS: CLEAR_VALIDATED_PRODUCTS_EQUITY';

export const GET_TEMPLATE_DETAILS = 'MORE:GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS = 'MORE:GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE = 'MORE:GET_TEMPLATE_DETAILS_FAILURE';

export const TYPE_FILTER_HANDLE = 'TYPE_FILTER_HANDLE';
export const TEMPLATE_FLAG = 'TEMPLATE_FLAG';

export const GET_FILTER_SEARCH_DATA = 'GET_FILTER_SEARCH_DATA';
export const GET_FILTER_SEARCH_DATA_SUCCESS = 'GET_FILTER_SEARCH_DATA_SUCCESS';
export const GET_FILTER_SEARCH_DATA_FAILURE = 'GET_FILTER_SEARCH_DATA_FAILURE';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const CLEAR_SEARCH_FILTER = 'CLEAR_SEARCH_FILTER';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SET_MAST_ORDER_TEMPLATE = 'SET_MAST_ORDER_TEMPLATE';
